import React from 'react';
import styled from '@emotion/styled';
import image from '../images/404.jpg';
import ErrorContent from './ErrorContent';

const Styled404Container = styled.div`
  background: #0e303a url('${image}') center 30px no-repeat;
  background-size: 575px 790px;
  width: 100%;
  height: 100%;
  position: absolute;
`;

export default () => {
  const primaryMessage = 'Oops.';
  const secondaryMessage = "We can't find that page!";
  return (
    <Styled404Container>
      <ErrorContent primaryMessage={primaryMessage} secondaryMessage={secondaryMessage} />
    </Styled404Container>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/Error404.jsx